import React from 'react';
import {Link, matchPath, useLocation} from 'react-router-dom';

function SurveyPageMenu(props) {
    const {pathname} = useLocation();
    const pathMach =  matchPath(pathname, { path:"/:survey/:subMenu/:surveyId" });
    let params;
    if(pathMach) {
        params = pathMach.params;
    }

    const surveyIdPathVar = params ? (params.surveyId ? "/" + params.surveyId : "") : "";

    return (
        <ul className={"questionaire__menu" + (location.pathname.includes("/survey/reports") ? " questionaire__menu--reports" : "")}>
            <li className={"questionaire__menu__item questionaire__menu__item--builder " + (location.pathname.includes("/survey/builder") ? " questionaire__menu__item--active" : "")}>
                <Link to={"/survey/builder" + surveyIdPathVar}>Builder</Link></li>
            <li className={"questionaire__menu__item questionaire__menu__item--test " + (location.pathname.includes("/survey/preview") ? " questionaire__menu__item--active" : "")}>
                <Link to={"/survey/preview" + surveyIdPathVar}>Preview</Link></li>
            <li className={"questionaire__menu__item questionaire__menu__item--share " + (location.pathname.includes("/survey/share") ? " questionaire__menu__item--active" : "")}>
                <Link to={"/survey/share" + surveyIdPathVar} >Share</Link></li>
            <li className={"questionaire__menu__item questionaire__menu__item--reports " + (location.pathname.includes("/survey/reports") ? " questionaire__menu__item--active" : "")}>
                <Link to={"/survey/reports" + surveyIdPathVar}>Reports</Link>
            </li>
        </ul>
    )
}

export default SurveyPageMenu;